import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

/* Vuetify */
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

/* ✅ MDI Icons (ADD THIS) */
import "@mdi/font/css/materialdesignicons.css";

/* Global styles */
import "./styles/global.css";

/* SEO */
import { createMetaManager } from "vue-meta";
import { createHead } from "@vueuse/head";

const vuetify = createVuetify({
  components,
  directives,

  /* ✅ ICON CONFIG (ADD THIS) */
  icons: {
    defaultSet: "mdi",
  },

  theme: {
    defaultTheme: "fashion",
    themes: {
      fashion: {
        colors: {
          primary: "#490917", // Rose Gold
          secondary: "#EEE7DA", // Soft blush
          background: "#FFF9F9",
          surface: "#FFFFFF",
        },
      },
    },
  },
});

const head = createHead();

createApp(App)
  .use(router)
  .use(vuetify)
  .use(createMetaManager())
  .use(head)
  .mount("#app");
